import ButtonToolbar from "@rio-cloud/rio-uikit/ButtonToolbar";
import { DatePicker } from "@rio-cloud/rio-uikit";
import moment, { Moment } from "moment";
import Button from "@rio-cloud/rio-uikit/Button";
import TableSettingsDialog from "@rio-cloud/rio-uikit/TableSettingsDialog";
import TableSearch from "@rio-cloud/rio-uikit/TableSearch";
import TableToolbar from "@rio-cloud/rio-uikit/TableToolbar";
import TableViewToggles, { type TableViewTogglesViewType } from "@rio-cloud/rio-uikit/TableViewToggles";

export type ColumnLabel = { [key: string]: string };

export type ColumnDetails = {
  [key: string]: number;
};

export type ColumnDetailsMap = {
  [key: string]: ColumnDetails;
};

interface Props {
  searchValue: string;
  viewType: "SINGLE_CARD" | "MULTI_CARDS" | "TABLE";
  showTableSettingsDialog: boolean;
  defaultColumnOrder: string[];
  columnOrder: string[];
  hiddenColumns: string[];
  columnLabels: ColumnLabel;
  disabledColumns: string[];
  columnsDetails: ColumnDetailsMap;
  startDate: string;
  endDate: string;
  handleSearchValueChange: (newSearchValue: string) => void;
  handleViewTypeChange: (newViewType: TableViewTogglesViewType) => void;
  handleToggleTableSettingsDialog: () => void;
  handleColumnChange: (
    newColumnOrder: string[],
    newHiddenColumns: string[],
    newColumnsDetails?: ColumnDetailsMap
  ) => void;
  handleColumnDetailsChange: (column: string, newColumnDetails: ColumnDetails) => void;
  handleStartDate: (date: string) => void;
  handleEndDate: (date: string) => void;
  handleRefresh: () => void;
  handleDownload: () => void;
  openModal?: (open: boolean) => void;
}

const Toolbar = ({
  searchValue,
  viewType,
  showTableSettingsDialog,
  defaultColumnOrder,
  columnOrder,
  columnLabels,
  hiddenColumns,
  disabledColumns,
  columnsDetails,
  startDate,
  endDate,
  handleSearchValueChange,
  handleViewTypeChange,
  handleToggleTableSettingsDialog,
  handleColumnChange,
  handleColumnDetailsChange,
  handleStartDate,
  handleEndDate,
  handleRefresh,
  handleDownload,
  openModal,
}: Props) => {
  const getStartDateValidation = (current: Moment) => {
    if (!endDate) return true;
    const minDate = moment(endDate).subtract(1, "year");
    const maxDate = moment(endDate);
    return current.isSameOrAfter(minDate, "day") && current.isSameOrBefore(maxDate, "day");
  };

  const getEndDateValidation = (current: Moment) => {
    if (!startDate) return true;
    const minDate = moment(startDate);
    const maxDate = moment(startDate).add(1, "year");
    return current.isSameOrAfter(minDate, "day") && current.isSameOrBefore(maxDate, "day");
  };

  return (
    <TableToolbar>
      <div className="table-toolbar-container">
        <div className="table-toolbar-group-left">
          <div className="table-toolbar-column table-toolbar-column-spacer">
            <ButtonToolbar className="display-grid grid-cols-3 display-flex-ls">
              <Button
                bsStyle={Button.PRIMARY}
                iconName="rioglyph-plus"
                className="rounded-small width-150"
                onClick={() => openModal && openModal(true)}
              >
                Nova despesa
              </Button>
            </ButtonToolbar>
          </div>
          <div className="table-toolbar-column  display-flex flex-row gap-10 align-items-center">
            <div className="width-150">
              <DatePicker
                id="1"
                dateFormat="DD/MM/YYYY"
                className="rounded-small"
                timeFormat={false}
                value={moment(startDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
                onChange={(result: Moment | string) => handleStartDate(moment(result).format("YYYY-MM-DD"))}
                isValidDate={getStartDateValidation}
              />
            </div>
            <div>
              <span className="text-normal text-size-14 text-color-darkest">até</span>
            </div>
            <div className="width-150">
              <DatePicker
                id="2"
                className="rounded-small"
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                value={moment(endDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
                onChange={(result: Moment | string) => handleEndDate(moment(result).format("YYYY-MM-DD"))}
                isValidDate={getEndDateValidation}
              />
            </div>
            <div>
              <TableSearch
                className="rounded-small width-300"
                value={searchValue}
                onChange={handleSearchValueChange}
                placeholder="Buscar"
              />
            </div>
          </div>
        </div>

        <div className="table-toolbar-group-right">
          <div className="table-toolbar-column table-toolbar-column-spacer">
            <TableViewToggles
              initialViewType={viewType}
              className="rounded-small"
              onViewTypeChange={handleViewTypeChange}
              tableViewTooltipContent="Tabela"
              singleCardViewTooltipContent="Lista"
              multiCardsViewTooltipContent="Cards"
            />
          </div>
          <div className="table-toolbar-column">
            <div className="btn-group rounded-small">
              <Button iconOnly iconName="rioglyph rioglyph-refresh" onClick={handleRefresh} />
              <Button iconOnly iconName="rioglyph rioglyph-download" onClick={handleDownload} />
              <Button iconOnly iconName="rioglyph rioglyph-cog" onClick={handleToggleTableSettingsDialog} />
            </div>
          </div>
        </div>

        {showTableSettingsDialog && (
          <TableSettingsDialog
            show={showTableSettingsDialog}
            title="Configurações"
            onHide={handleToggleTableSettingsDialog}
            onColumnChange={handleColumnChange}
            defaultColumnOrder={defaultColumnOrder}
            defaultHiddenColumns={[]}
            columnOrder={columnOrder}
            hiddenColumns={hiddenColumns}
            columnLabels={columnLabels}
            disabledColumns={disabledColumns}
            closeButtonText="Fechar"
            resetButtonText="Default"
            searchPlaceholder="Nome da coluna"
            notFoundMessage="Sem coluna cadastrada no momento"
            columnsDetails={columnsDetails}
            autoLabel="Auto"
            onColumnDetailsChange={handleColumnDetailsChange}
            onSearchChange={(val: string) => console.log(val)}
            immediateChange
          />
        )}
      </div>
    </TableToolbar>
  );
};

export default Toolbar;
